export class SaleModel {
  amount: number;
  code: string;

  constructor(obj) {
    this.amount = obj.amount;
    this.code = obj.code;
  }

  getBillingCycleText(prefix: string) {
    if (this.code === 'monthly') {
      return `${prefix} month`;
    } else if (this.code === 'yearly') {
      return `${prefix} year`;
    }

    return '';
  }
}

export class Plan {
  uuid: string;
  name: string;
  description: string;
  saleModels: SaleModel[];
  selected: boolean;
  selectedSaleModel: SaleModel;
  //ui
  isSaleModeCode?: boolean;
  price?: number;

  constructor(obj) {
    this.uuid = obj.uuid;
    this.name = obj.name;
    this.description = obj.description;
    this.saleModels = obj.saleModels.map(x => new SaleModel(x));
    this.selected = obj.selected;
    this.selectedSaleModel = new SaleModel(obj.selectedSaleModel);
  }
}

export class Product {
  name: string;
  logo: string;

  constructor(obj) {
    this.name = obj.name;
    this.logo = obj.logo;
  }

  isAppDeveloperConsole() {
    return this.name === 'Developer Console Beta' || this.name === 'Developer Console';
  }
}

export class PurchaseModel {
  productId?: string;
  currency: string;
  plans: Plan[];
  name: string;
  icon: string;

  constructor(obj) {
    this.currency = obj.currency;
    this.name = obj.name;
    this.icon = obj.icon;
    this.plans = obj.plans.map(x => new Plan(x));
  }

  hasManyPlans(): boolean {
    return this.plans.length > 1;
  }
}
